/**
 * Mixin for measuring text width in the DOM.
 * Each instance gets its own isolated measuring div for accurate text measurements.
 */
export default {
    data() {
        return {
            _measuringDiv: null
        };
    },

    methods: {
        // Ensures the measuring div exists and returns it
        _getMeasuringDiv() {
            if (!this._measuringDiv) {
                this._measuringDiv = this._createMeasuringDiv();
            }
            return this._measuringDiv;
        },

        // Measures the width of text and returns it in pixels
        measureText(text) {
            const div = this._getMeasuringDiv();
            div.textContent = text ?? '';
            return div.offsetWidth;
        },

        // Creates a hidden div for text measurements
        _createMeasuringDiv() {
            const div = document.createElement('div');
            div.style.position = 'absolute';
            div.style.visibility = 'hidden';
            div.style.whiteSpace = 'nowrap';
            div.style.fontSize = '0.95rem';
            div.style.fontFamily = getComputedStyle(document.body).fontFamily;
            div.setAttribute('aria-hidden', 'true');
            document.body.appendChild(div);
            return div;
        },

        // Cleans up DOM resources
        cleanupTextMeasurement() {
            if (this._measuringDiv && this._measuringDiv.parentNode) {
                document.body.removeChild(this._measuringDiv);
                this._measuringDiv = null;
            }
        }
    },

    beforeDestroy() {
        this.cleanupTextMeasurement();
    }
};
